import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner, Table } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { globalFormManagementServices } from "../../../../APIServices/globalFormManagementServices";
import { studyLevelFormManagementServices } from "../../../../APIServices/studyLevelFormManagementServices";
import { NoDataFoundTable } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import Loader from "../../../../img/Document scan.gif" 

const PullGlobalFormMetadata = ({
  Show,
  Hide,
  Title,
  tableRef,
  onMouseDown,
  getStudyLevelForm,
  formCodeList,
}) => {
  const [formMetadataList, setFormMetadataList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedFormIds, setSelectedFormIds] = useState([]);
  const [pullButtonLoader, setPullButtonLoader] = useState(false);
  const LoginCat = JSON.parse(localStorage.getItem("role")).toLowerCase();
  let { studyId } = useParams();
  const getGlobalFormByCategory = async (e) => {
    setLoading(true);
    let data = await globalFormManagementServices.getGlobalFormByCategory(LoginCat);
    const filtered = (data?.data || [])?.filter(
      (item) => !formCodeList?.includes(item.formCode)
    );
    setFormMetadataList(filtered || []);
    setLoading(false);
  };

  const pullGlobalForminStudyLevelForm = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Pull Selected form in Study!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, pull it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setPullButtonLoader(true);
        let userData = {};
        userData.studyId = studyId;
        userData.formIds = selectedFormIds;
        let data =
          await studyLevelFormManagementServices.pullGlobalForminStudyLevelForm(
            userData
          );
        if (data?.statusCode === 200) {
          getStudyLevelForm();
          setSelectedFormIds([]);
          Hide();
        }
      }
      setPullButtonLoader(false);
    });
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allIds = formMetadataList.map((item) => item.formId);
      setSelectedFormIds(allIds);
    } else {
      setSelectedFormIds([]);
    }
  };

  const handleSingleSelect = (formId) => {
    setSelectedFormIds((prevSelected) =>
      prevSelected.includes(formId)
        ? prevSelected.filter((id) => id !== formId)
        : [...prevSelected, formId]
    );
  };

  const isAllSelected =
    formMetadataList?.length > 0 &&
    selectedFormIds?.length === formMetadataList?.length;

  useEffect(() => {
    getGlobalFormByCategory();
  }, [formCodeList]);
  return (
    <>
      <Offcanvas
        show={Show}
        onHide={Hide}
        style={{ width: 575 }}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          {loading ? (
            <div className="hstack justify-content-center h-100">
              <img src={Loader} alt=""/>
            </div>
          ) : formMetadataList?.length === 0 ? (
            <div className="hstack justify-content-center h-100">
              <NoDataFoundTable MSG={"Global Form Metadata not found!"} />
            </div>
          ) : (
            <>
              <Table ref={tableRef} className="m-0 custom-table" hover striped>
                <thead className="position-sticky top-0 z-1">
                  <tr>
                    <th style={{ width: 45 }} className="text-center">
                      <Form.Check
                        type="checkbox"
                        onChange={handleSelectAll}
                        checked={isAllSelected}
                      />
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 1)}>Form Name</th>
                    <th
                      style={{ width: 100 }}
                      onMouseDown={(e) => onMouseDown(e, 2)}
                    >
                      Form Type
                    </th>
                    <th
                      style={{ width: 100 }}
                      onMouseDown={(e) => onMouseDown(e, 3)}
                    >
                      Special Form
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {formMetadataList?.map((metadata, index) => (
                    <tr key={index} title="View Details">
                      <td className="text-center">
                        <Form.Check
                          type="checkbox"
                          checked={selectedFormIds.includes(metadata.formId)}
                          onChange={() => handleSingleSelect(metadata.formId)}
                        />
                      </td>
                      <td>{metadata?.formName}</td>
                      <td className="text-capitalize">{metadata?.formType}</td>
                      <td className="text-capitalize">
                        {metadata?.specialForm}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </>
          )}
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top shadow-sm hstack justify-content-end gap-2">
          <button
            onClick={pullGlobalForminStudyLevelForm}
            disabled={selectedFormIds?.length === 0 || pullButtonLoader}
            className="updateProfile"
          >
            {pullButtonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm"/> Pulling...
              </div>
            ) : (
              "Pull Now"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default PullGlobalFormMetadata;
